/** @module Apparel/NewStyleWizard */
define([
	"dojo/_base/declare",
	"csi/wizard/ActionControllerMixin",
	"./NewStyle",
	"./_StyleWizardMixIn"
], function(declare, ActionControllerMixin, NewStyle, _StyleWizardMixIn) {

	return declare([NewStyle, ActionControllerMixin, _StyleWizardMixIn], {
		idWizardResource: "NewStyle",

		/**
		 * @override
		 * Allow user to Save & New
		 */
		_canRepeat: function() {
			return true;
		}
	});
});
